const KEY = "iper_calcs_v1";

export function listCalcs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  } catch {
    return [];
  }
}

export function saveCalc(nome, result) {
  const items = listCalcs();
  const doc = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    nome,
    created_at: new Date().toISOString(),
    result,
  };
  items.push(doc);
  localStorage.setItem(KEY, JSON.stringify(items));
  return doc;
}

export function deleteCalc(id) {
  const items = listCalcs().filter((it) => it.id !== id);
  localStorage.setItem(KEY, JSON.stringify(items));
}
